<rask-fieldset-toggle label="Anskaffningsform"
    [formGroup]="form"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-tree-selector
        class="w-100"
        placeholder="Välj anskaffningsform"
        label="Anskaffningsform"
        (change)="setAnskaffningsformFromSelector()"
        [items]="selectableAnskaffningsformer">
    </rask-tree-selector>
</rask-fieldset-toggle>